<template>
  <div class="page_content">

    <div class="dd_confirm">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <h1>Controleer je adresgegevens</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="dd_conf_box">
            <div class="content">
              <div class="title">{{ getDeliveryDetails.gender }} {{
                getDeliveryDetails.firstname
                }} {{ getDeliveryDetails.lastname }}
              </div>
              <div class="info">{{ getDeliveryDetails.msisdn }}</div>
              <div class="info">{{ getDeliveryDetails.email }}</div>
              <div v-if="getDeliveryDetails.addressAddOn!=null" class="info">
                 {{ getDeliveryDetails.address }} {{ getDeliveryDetails.houseNumber }}, {{ getDeliveryDetails.addressAddOn }}, {{ getDeliveryDetails.postalCode }},
              </div>
              <div v-else class="info">{{ getDeliveryDetails.address }} {{ getDeliveryDetails.houseNumber }}, {{ getDeliveryDetails.postalCode }},</div>
              <div class="info">{{ getDeliveryDetails.city }}</div>
              <div class="row justify-content-center btn_content air_btn">
                <button type="button" @click.prevent="backToDeliveryDetails" class="black_secondary_btn mr-1">Veranderen</button>
                <button type="button" @click.prevent="saveDeliveryDetails" :disabled="disabled" class="black_btn ml-1">Bevestigen</button>
              </div>
              <div class="desc">
                Deze gegevens worden uitsluitend voor het verzenden van je prijs gebruikt.
                Telefoonnummer en e-mailadres zijn nodig om je eventueel te kunnen bereiken over
                het afleveren van je prijs. Let op: controleer je adresgegevens, want het adres
                kan naderhand niet meer aangepast worden.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import router from '../router';
  import gameFlow from '../common/mixin/gameFlow';

  export default {
    name: 'DeliveryDetailsConfirmation',
    mixins: [
      gameFlow
    ],
    data() {
      return {
        disabled: false
      }
    },
    computed: {
      ...mapGetters([
        'getSelectedTelcoReward',
        'getDeliveryDetails',
        'getExtraChance'
      ])
    },
    mounted() {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.setInGameFlow("true", this.$route.path.substring(1))
    },
    methods: {
      ...mapActions([
        'saveDeliveryData'
      ]),
      backToDeliveryDetails() {
        router.push({name: 'DeliveryDetails'})
      },
      saveDeliveryDetails() {
        if (this.disabled) {
          return
        }
        this.disabled = true
        this.saveDeliveryData(this.getDeliveryDetails)
          .then((response) => {
            this.$store.commit('updateGameResponse', response.data.params)
            if (!this.getExtraChance) {
              this.assignTelcoReward(true, this.getSelectedTelcoReward, false)
            } else {
              router.push({name: 'SocialShare'})
            }
          })
          .catch((error) => {
            console.log('an error occurred: ' + error)
            this.disabled = false
            // this.redirectUserOnError()
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DeliveryDetailsConfirmation.vue